import ajax from '../Common/API/ajax'
// import storage from 'Common/API/Storage'
// import device from 'Common/API/Device'
import util from '../Common/API/util'
// import wx from 'Common/API/WX'
// import googleMap from 'Common/API/GoogleMap'
import _aspect from '../Common/API/iView'
const noParams={}
export default {
    util,
    admin: {
        signIn(params) {
            return ajax.post('/admin/signIn', params)
        },
        sync() {
            return ajax.get('/admin/sync')
        },
        signOut() {
            return ajax.delete('/admin/signOut')
        },
    },

    player: {
      searchPage (condition, page) {
        return ajax.post('/player/searchPage', {condition, page})
      },
      create(params) {
        return ajax.post('/player/create', params)
      },
      update (params) {
        return ajax.post('/player/update', params)
      },
      delete(id) {
        return ajax.delete('/player/' + id)
      },
    },

    challenge: {
      searchPage (condition, page) {
        return ajax.post('/challenge/searchPage', {condition, page})
      },
      create(params) {
        return ajax.post('/challenge/create', params)
      },
      update(params) {
        return ajax.post('/challenge/update', params)
      },
      delete(id) {
        return ajax.delete('/challenge/' + id)
      },
    },

    player_challenge: {
      searchPage (condition, page) {
        return ajax.post('/player_challenge/searchPage', {condition, page})
      },
      list (params) {
        return ajax.post('/player_challenge/list', params)
      },
    },

    gift: {
      searchPage (condition, page) {
        return ajax.post('/gift/searchPage', {condition, page})
      },
      create(params) {
        return ajax.post('/gift/create', params)
      },
      update(params) {
        return ajax.post('/gift/update', params)
      },
      delete(id) {
        return ajax.delete('/gift/' + id)
      },
    },

    shop: {
      searchPage (condition, page) {
        return ajax.post('/shop/searchPage', {condition, page})
      },
      create(params) {
        return ajax.post('/shop/create', params)
      },
      update(params) {
        return ajax.post('/shop/update', params)
      },
      delete(id) {
        return ajax.delete('/shop/' + id)
      },
    },

    redeem: {
      searchPage (condition, page) {
        return ajax.post('/redeem/searchPage', {condition, page})
      },
      list (params) {
        return ajax.post('/redeem/list', params)
      },
      update(params) {
        return ajax.post('/redeem/update', params)
      },
    },

    delivery: {
      searchPage (condition, page) {
        return ajax.post('/delivery/searchPage', {condition, page})
      },
    },
  

    file: {
      imageUpload() {
        return ajax.post('/file/imageUpload')
      }
    },
    scan_data: {
      searchGTScanPage (condition, page) {
        return ajax.post('/scan_data/searchGTScanPage', {condition, page})
      },
      searchDragonScanPage (condition, page) {
        return ajax.post('/scan_data/searchDragonScanPage', {condition, page})
      },
      searchCut3ScanPage (condition, page) {
        return ajax.post('/scan_data/searchCut3ScanPage', {condition, page})
      },
      searchBook1ScanPage (condition, page) {
        return ajax.post('/scan_data/searchBook1ScanPage', {condition, page})
      },
      searchChblScanPage (condition, page) {
        return ajax.post('/scan_data/searchChblScanPage', {condition, page})
      },
      searchYlwScanPage (condition, page) {
        return ajax.post('/scan_data/searchYlwScanPage', {condition, page})
      },
      searchRtpScanPage (condition, page) {
        return ajax.post('/scan_data/searchRtpScanPage', {condition, page})
      },
      searchFreak6ScanPage (condition, page) {
        return ajax.post('/scan_data/searchFreak6ScanPage', {condition, page})
      },
    },
    cut3_hexiao: {
      searchPage (condition, page) {
        return ajax.post('/hexiao/searchPage', {condition, page})
      },
      test(arr) {
        return ajax.post('/tracking_system/test', arr)
      }
    },
    nby_shop: {
      searchPage (condition, page) {
        return ajax.post('/nby_shop/searchPage', {condition, page})
      },
      create(params) {
        return ajax.post('/nby_shop/create', params)
      },
      update(params) {
        return ajax.post('/nby_shop/update', params)
      },
      delete(id) {
        return ajax.delete('/nby_shop/' + id)
      },
    },
    chbl_team: {
      searchPage (condition, page) {
        return ajax.post('/chbl_team/searchPage', { condition, page })
      },
      create(params) {
        return ajax.post('/chbl_team/create', params)
      },
      update(params) {
        return ajax.post('/chbl_team/update', params)
      },
      delete(id) {
        return ajax.delete('/chbl_team/' + id)
      },
    },
    hoi_data: {
      searchAirmaxPage (condition, page) {
        return ajax.post('/hoi/searchAirmaxScanPage', { condition, page })
      },
      searchAirmaxChallengePage (condition, page) {
        return ajax.post('/hoi/searchAirmaxChallengePage', { condition, page })
      },
      searchRtpPage (condition, page) {
        return ajax.post('/hoi/searchRtpScanPage', { condition, page })
      },
      searchRtpChallengePage (condition, page) {
        return ajax.post('/hoi/searchRtpChallengePage', { condition, page })
      },
    },

    chbl_temp: {
      searchPage (condition, page) {
        return ajax.post('/chbl_temp/searchPage', { condition, page })
      },
    },
    chbl_2026: {
      searchPage (condition, page) {
        return ajax.post('/chbl2026/getData', {condition, page})
      },
    },

}



// WEBPACK FOOTER //
// ./src/API/index.js